import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import WCCVimeoVideo from 'models/attachments/vimeo';
import { IWCCPlayerVM } from '../../players/player.interfaces';
import './vimeo.html';
import './vimeo.scss';

export interface WCCVimeoVideoVMConfig {
    video: SubscribableOrNullableValue<WCCVimeoVideo>
    ratio: SubscribableOrNullableValue<number>
}

@injectable()
export default class WCCVimeoVideoVM {
    player = ko.observable<IWCCPlayerVM>();

    code: Subscribable<string | undefined>
    ratio: Subscribable<number | undefined>

    constructor(
        @inject(wccModules.componentConfig) config: WCCVimeoVideoVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const video = ko.flattenComputed(config.video);
        this.code = video.pluck(v => v.link);

        this.ratio = ko.flattenComputed(config.ratio);

        const isReady = ko.pureComputed(() => this.player()?.isReady() ?? false);

        ko.applyBindingsToNode(info.element, {
            'visible': isReady,

            'css': {
                'wcc-vimeo-video': true
            }
        });
    }
}